import {
  FETCH_APPEND_CONVERSATIONS, FETCH_APPEND_CONVERSATIONS_FAILED, FETCH_APPEND_CONVERSATIONS_SUCCESS,
  FETCH_CONVERSATIONS,
  FETCH_CONVERSATIONS_FAILED,
  FETCH_CONVERSATIONS_SUCCESS, REFETCH_MESSAGE, RESET_CONVERSATIONS, SET_CONVERSATION_CONTENT_LOADING,
  SET_CONVERSATION_PAGE,
  SET_CONVERSATION_RECORD_PER_PAGE,
  SET_CONVERSATION_SELECTED, SET_CONVERSATION_TYPE, SET_CONVERSATIONS_LOADING
} from './actions';
import {CHAT_GROUP} from "@iso/components/ChatDrawer/ChatDrawer";

const initialState = {
  conversations: [],
  type: CHAT_GROUP.WORKING,
  selected: null,
  isLoading: true,
  page: 1,
  recordPerPage: 20,
  error: null,
  refetchMessage: false,
  isLoadContent: true
};

export default function chatReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CONVERSATION_SELECTED:
      return {
        ...state,
        isLoadContent: true,
        selected: action.payload,
      };
    case SET_CONVERSATION_CONTENT_LOADING:
      return {
        ...state,
        isLoadContent: action.payload,
      };
    case SET_CONVERSATION_PAGE:
      return {
        ...state,
        page: action.payload
      }
    case SET_CONVERSATION_RECORD_PER_PAGE:
      return {
        ...state,
        recordPerPage: action.payload
      }
    case SET_CONVERSATION_TYPE:
      return {
        ...state,
        type: action.payload
      }
    case FETCH_CONVERSATIONS:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_CONVERSATIONS_SUCCESS:
      return {
        ...state,
        conversations: action.payload,
        isLoading: false
      };
    case FETCH_CONVERSATIONS_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case FETCH_APPEND_CONVERSATIONS:
      return {
        ...state,
        isLoading: true
      };
    case FETCH_APPEND_CONVERSATIONS_SUCCESS:
      const page = action.payload && action.payload.length <= 0 && state.page > 1 ?
        state.page - 1 : state.page;

      return {
        ...state,
        conversations: [
          ...state.conversations,
          ...action.payload
        ],
        page: page,
        isLoading: false
      };
    case FETCH_APPEND_CONVERSATIONS_FAILED:
      return {
        ...state,
        error: action.payload,
        isLoading: false
      };
    case SET_CONVERSATIONS_LOADING:
      return {
        ...state,
        isLoading: action.payload
      }
    case RESET_CONVERSATIONS:
      return {
        ...state,
        conversations: []
      }
    case REFETCH_MESSAGE:
      return {
        ...state,
        refetchMessage: !state.refetchMessage
      }
    default:
      return state
  }
}
